module.exports = __webpack_public_path__ + "static/img/1980.f30fa936.jpg";